import { createAPI } from '@common'
export default {
  postSitesOpen: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0pqfo', 'POST', config),
  postSitesDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0efmfuf', 'POST', config),
  postSitesClose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0dmptf', 'POST', config),
  authorization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0bvuipsj{bujpo', 'GET', config),
  // 授权情况概览
  getDeployOverview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0efqmpz0pwfswjfx', 'GET', config),
  // 新建/修改站点
  postSites: (config) => createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft', 'POST', config),
  // 查看授权清单
  getSitesAuthorization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0bvuipsj{bujpo', 'GET', config),
  // 读所有站点列表
  getSites: (config) =>
    // 是否应该通过这种方式统一处理站点接口的base-param
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft', 'GET', {
      ...config
    }),
  // 读所有其他稿库可访问的app站点web站点微信账号列表
  getAllSites: (config) =>
    // 是否应该通过这种方式统一处理站点接口的base-param
    createAPI('customEncryptApiName-1/0nfejby.tjuf0bmmTjuft', 'GET', {
      ...config
    }),
  // 读站点模板配置初始化数据
  getTemplateConfigInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0ufnqmbufDpogjhJoju', 'GET', config),  
  // 站点模板配置保存
  postTemplateConfigSave: (config) => createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft0ufnqmbufDpogjhTbwf', 'POST', config),  
}
